import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function get_current_base_target_month_date(params: Record<string, any>) {
  return request.post('/mjstat/get_current_base_target_month_date', params);
}
export async function create_base_target(params: Record<string, any>) {
  return request.post('/mjstat/create_base_target', params);
}
export async function set_shop_target(params: Record<string, any>) {
  return request.post('/mjstat/set_shop_target', params);
}
export async function get_shop_target_detail(params: Record<string, any>) {
  return request.post('/mjstat/get_shop_target_detail', params);
}
export async function get_stat_tag_list(params: Record<string, any>) {
  return request.post('/mjstat/get_stat_tag_list', params);
}

export async function query_shop_target_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstat/query_shop_target_list', params);
}

export async function query_customer_remain_money_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/query_customer_remain_money_list', params);
}
export async function query_stat_by_staff(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstat/query_stat_by_staff', params);
}
export async function query_stat_by_shop(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstat/query_stat_by_shop', params);
}
export async function query_stat_by_area(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstat/query_stat_by_area', params);
}
export async function query_stat_by_shop_type(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/query_stat_by_shop_type', params);
}
export async function query_stat_by_leader(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstat/query_stat_by_leader', params);
}
export async function query_stat_by_shop_ids(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstat/query_stat_by_shop_ids', params);
}
export async function query_graph_and_rank_by_shop_ids(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/query_graph_and_rank_by_shop_ids', params);
}
export async function create_shop_operation_target(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/create_shop_operation_target', params);
}
export async function update_shop_operation_target(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/update_shop_operation_target', params);
}
export async function query_shop_operation_target_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/query_shop_operation_target_list', params);
}
export async function create_staff_operation_target(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/create_staff_operation_target', params);
}
export async function update_staff_operation_target(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/update_staff_operation_target', params);
}
export async function query_staff_operation_target_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstat/query_staff_operation_target_list', params);
}
export async function bulk_create_shop_operation_target(params: Record<string, any>) {
  return request.post('/mjstat/bulk_create_shop_operation_target', params);
}
export async function bulk_create_staff_operation_target(params: Record<string, any>) {
  return request.post('/mjstat/bulk_create_staff_operation_target', params);
}
export async function query_shop_operation_list(params: Record<string, any>) {
  const res: PageResult = await request.post('/mjstat/query_shop_operation_list', params);
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_staff_operation_list(params: Record<string, any>) {
  const res: PageResult = await request.post('/mjstat/query_staff_operation_list', params);
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_customer_operation_daily_report_list(params: Record<string, any>) {
  return request.post('/mjstat/query_customer_operation_daily_report_list', params);
}
